module.exports = require("@swa-ui/application/src/AppFooter/AppFooter.module.scss");